module.exports = __webpack_public_path__ + "assets/images/project/india-desktop.jpg?v=37c62e91";